import React, { useEffect } from 'react';
import { Alert, Box } from '@mui/material';
import { useConnectionStatus } from '../hooks/useConnectionStatus';
import firebase from 'lib/firebase';

const OfflineAwareWrapper = ({ children }) => {
  const {
    isOnline,
    hasLocalData,
    isOfflineCapable,
    firebaseConnected,
    firebaseConfigured,
  } = useConnectionStatus();

  // Add debug logging
  useEffect(() => {
    /*
     * [1854-REFRACTION] console.info('Connection Status:', {
     *   isOnline,
     *   hasLocalData,
     *   isOfflineCapable,
     *   firebaseInitialized: !!firebase.db,
     *   firebaseConfigured: !!firebase.isConfigured,
     *   hookFirebaseConnected: firebaseConnected,
     *   hookFirebaseConfigured: firebaseConfigured,
     *   missingConfigKeys: firebase.missingConfigKeys
     * });
     */
  }, [firebaseConfigured, firebaseConnected, hasLocalData, isOfflineCapable, isOnline]);

  const shouldShowDebugAlert = process.env.NODE_ENV !== 'production';

  // Only surface the detailed status card for non-production environments.
  if (shouldShowDebugAlert && !isOfflineCapable && firebase.db) {
    return (
      <Box>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Connection Status:
          <ul>
            <li>Online: {isOnline.toString()}</li>
            <li>Has Local Data: {hasLocalData.toString()}</li>
            <li>Firebase Initialized: {(!!firebase.db).toString()}</li>
          </ul>
          Please check your internet connection and try again.
        </Alert>
        {children}
      </Box>
    );
  }

  // If we're offline but have local data, show info message
  if (!isOnline && hasLocalData) {
    return (
      <Box>
        <Alert severity="info" sx={{ mb: 2 }}>
          You are currently offline. Some features may be limited, but cached data is available.
        </Alert>
        {children}
      </Box>
    );
  }

  return children;
};

export default OfflineAwareWrapper;
